import React from "react";
import AlternativePathsPage from "Pages/AdministratorDashboard/Organization/CareerPath/AlternativePaths";

// Employee Dashboard mirror of the HR-side Alternative Career Paths page.
// Per Mudassir (May-20 doc): the UI is identical — only the API URL differs.
// Reusing the same component, just flipping the useMeEndpoint flag so the
// hook calls /api/CareerPath/me/career-path/alternatives instead of the
// HR-side /api/CareerPath/{employeeId}/career-path/alternatives.
const EmployeeAlternativePaths = () => {
  return <AlternativePathsPage useMeEndpoint={true} />;
};

export default EmployeeAlternativePaths;
